import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { useT } from "@/i18n";

const CONTACT = "emma-calc-contact";
export const savedContact = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CONTACT) || "null");
    return c?.first_name && c?.last_name && c?.email && c?.phone ? c : null;
  } catch {
    return null;
  }
};

const Field = ({ id, label, ...rest }) => (
  <label className="block">
    <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#A39E93]">{label}</span>
    <input className="field" required {...rest} data-testid={`sheet-gate-${id}`} />
  </label>
);

const ContactFields = ({ form, setForm, t }) => {
  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return <>
    <div className="grid gap-6 sm:grid-cols-2">
      <Field id="first-name" label={`${t("pdf.first", "Nome")} *`} value={form.first_name} maxLength={60} autoComplete="given-name" onChange={on("first_name")} />
      <Field id="last-name" label={`${t("pdf.last", "Cognome")} *`} value={form.last_name} maxLength={60} autoComplete="family-name" onChange={on("last_name")} />
    </div>
    <Field id="phone" label={`${t("pdf.phone", "Telefono")} *`} type="tel" value={form.phone} minLength={6} maxLength={40} autoComplete="tel" onChange={on("phone")} />
    <Field id="email" label="Email *" type="email" value={form.email} autoComplete="email" onChange={on("email")} />
  </>;
};

const GateForm = ({ onSubmit, submitLabel }) => {
  const t = useT();
  const [form, setForm] = useState({ first_name: "", last_name: "", phone: "", email: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!Object.values(form).every((v) => v.trim())) return toast.error(t("pdf.errContact", "Compila nome, cognome, email e telefono."));
    setLoading(true);
    try {
      await onSubmit({ ...form, consent: true });
      localStorage.setItem(CONTACT, JSON.stringify(form));
    } catch (err) {
      toast.error(err?.response?.status === 429 ? t("form.err429", "Troppe richieste, riprova più tardi.") : t("pdf.err", "Controlla l'email e riprova."));
    } finally {
      setLoading(false);
    }
  };
  return (
    <form onSubmit={submit} className="mt-6 grid gap-6" data-testid="sheet-gate-form">
      <ContactFields form={form} setForm={setForm} t={t} />
      <p className="text-sm leading-relaxed text-[#CFC8BC]" data-testid="sheet-gate-auto-consent">{t("pdf.autoConsent", "Scaricando accetti il trattamento dei dati e di ricevere da Emma Industrie informazioni, pubblicazioni, comunicazioni pubblicitarie e inviti a eventi.")}</p>
      <button type="submit" disabled={loading} className="btn-amber w-fit disabled:opacity-60" data-testid="sheet-gate-submit">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} {submitLabel}
      </button>
    </form>
  );
};

export const EmailGate = ({ open, onClose, title, description, submitLabel, onSubmit, doneHref, doneLabel }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-h-[92dvh] w-[calc(100%-1.5rem)] overflow-y-auto border-white/10 bg-[#1B1816] text-[#F7F5F0] sm:max-w-lg" data-testid="sheet-gate-dialog">
      <Lock className="h-6 w-6 text-[#D98A52]" />
      <DialogTitle className="font-display text-2xl font-bold">{title}</DialogTitle>
      <DialogDescription className="text-[#CFC8BC]">{description}</DialogDescription>
      {doneHref ? (
        <a href={doneHref} download className="btn-amber mt-4 w-fit" data-testid="sheet-gate-link">{doneLabel} <Download className="h-4 w-4" /></a>
      ) : open && <GateForm onSubmit={onSubmit} submitLabel={submitLabel} />}
    </DialogContent>
  </Dialog>
);
